export default {
    redeemReferral: {
        data: null,
        loading: false,
        error: null,
        success: false,
      }, 
}